


















import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import DocumentAttachmentItem from './DocumentAttachmentItem.vue';

export default defineComponent({
  components: {
    DocumentAttachmentItem,
  },
  props: {
    documentAttachments: { type: Array as PropType<DocumentAttachment[]>, required: true },
    focusedRequiredId: { type: String, default: '' },
    theme: { type: Object as PropType<SigningTheme>, default: undefined },
    uploadingAttachmentIds: { type: Array as PropType<string[]>, default: () => [] },
    isSigned: { type: Boolean, default: false },
    isPreview: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const handleUploadAttachment = (payload: { attachmentId: string; name: string }) => {
      emit('uploadFile', payload);
    };
    const handleAttachmentView = (id: string) => {
      emit('attachmentView', id);
    };
    const isUploading = (attachmentId: string): boolean =>
      props.uploadingAttachmentIds.includes(attachmentId);

    return {
      handleUploadAttachment,
      handleAttachmentView,
      isUploading,
    };
  },
});
